import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingStyleOne = _resolveComponent("PricingStyleOne")!
  const _component_PricingStyleTwo = _resolveComponent("PricingStyleTwo")!
  const _component_PricingStyleThree = _resolveComponent("PricingStyleThree")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PricingStyleOne),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-4 pt-4" }, [
      _createElementVNode("h3", { class: "mb-0" }, "Pricing Plan 2")
    ], -1)),
    _createVNode(_component_PricingStyleTwo),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-4 pt-4" }, [
      _createElementVNode("h3", { class: "mb-0" }, "Pricing Plan 3")
    ], -1)),
    _createVNode(_component_PricingStyleThree)
  ]))
}